import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLang } from "@/i18n";

// Shows a fixed bottom-left "back to top" pill once the user has scrolled
// far enough (~240px). Uses `prefers-reduced-motion` to fall back to an
// instant jump when the OS asks for reduced motion. Designed to sit below
// the right-anchored Sonner toaster so the two never overlap on mobile.
const FloatingBackToTop = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible((window.scrollY || 0) > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const reduced =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label={t("nav.backToTopFloating")}
      title={t("nav.backToTopFloating")}
      className="fixed start-4 bottom-4 sm:start-6 sm:bottom-6 z-40 inline-flex items-center gap-2 bg-emerald-600 text-white font-semibold rounded-full px-4 py-2.5 shadow-lg shadow-emerald-600/30 hover:bg-emerald-700 transition-all"
      data-testid="floating-back-to-top"
    >
      <ArrowUp className="w-4 h-4" />
      <span className="hidden sm:inline">{t("nav.backToTopFloating")}</span>
    </button>
  );
};

export default FloatingBackToTop;
